<template>
    <main class="stats">
        <section class="list-banner">
            <div class="overlay"></div>
            <h1 class="banner-title">Means of transport</h1>
        </section>
        <SubMenu parent-route-name="stats" />
        <LoadingScreen
            v-if="!loaded"
            message="Loading transportation statistics…"
        />
        <section v-else class="max-width-container">
            <article>
                <h2>Means of Transport During Travel</h2>
                <DataTable v-if="loaded" :table="table" />
                <BaseChart
                    v-if="loaded"
                    name="Means of transport"
                    :options="chart"
                />
            </article>
        </section>
        <section class="actions">
            <router-link to="/stats">
                <Bttn class="outlined">Back</Bttn>
            </router-link>
        </section>
    </main>
</template>
<script>
import DataTable from "js/components/tables/DataTable";
import BaseChart from "js/components/charts/BaseChart";
import LoadingScreen from "js/components/common/LoadingScreen";
import { fetch } from "js/lib/server.js";
import { getBarChart } from "js/lib/charts.js";
export default {
    components: {
        LoadingScreen,
        DataTable,
        BaseChart,
    },
    data() {
        return {
            loaded: false,
            header: [],
            body: [],
            chart: [],
        };
    },
    mounted() {
        fetch("/api/stats/transport").then((response) => {
            this.table = response.data.table;

            this.chart = getBarChart(response.data.charts.mot.labels, [
                {
                    label: "Rides",
                    data: response.data.charts.mot.lines.rides,
                },
                {
                    label: "Trips",
                    data: response.data.charts.mot.lines.trips,
                },
            ]);

            this.loaded = true;
        });
    },
};
</script>
